<div class="font-base text-sm p-4 text-neutral-700 bg-neutral-100 rounded rounded-s mb-4">
  {{ 'payment.on-site-picker' | translate }}
</div>

<app-payment-panel-stripe-generic
  type="ONSITE"
  [payButtonText]="'payment.pay-with-credit-card' | translate"
></app-payment-panel-stripe-generic>
